import { createIcon } from '@chakra-ui/react';

export const MultiCardIcon = createIcon({
  displayName: 'MultiCardIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path
        d="M1.66602 10.5083H15.8327"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8327 8.56658V14.5249C15.8077 16.8999 15.1577 17.4999 12.6827 17.4999H4.81604C2.29937 17.4999 1.66602 16.8749 1.66602 14.3916V8.56658C1.66602 6.31658 2.19102 5.59159 4.16602 5.47492C4.36602 5.46659 4.58271 5.45825 4.81604 5.45825H12.6827C15.1993 5.45825 15.8327 6.08325 15.8327 8.56658Z"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 5.60833V11.4333C18.3327 13.6833 17.8077 14.4083 15.8327 14.525V8.56667C15.8327 6.08333 15.1993 5.45833 12.6827 5.45833H4.81604C4.58271 5.45833 4.36602 5.46667 4.16602 5.475C4.19102 3.1 4.84104 2.5 7.31604 2.5H15.1827C17.6993 2.5 18.3327 3.125 18.3327 5.60833Z"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 14.8416H5.80831"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5918 14.8416H10.4585"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
